import { createRouter, createWebHistory } from "@ionic/vue-router";
// import { RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";
import { apiIsLoggedIn } from "../api/auth";
import store from "../store";
// import Tabs from "../views/Tabs.vue";
// import IntroSlider from "../views/IntroSlider.vue";
// import Registrierung from "../views/Registrierung.vue";
// import Mtan from "../views/Mtan.vue";
// import Login from "../views/Login.vue";
// import WelcomeScreen from "../views/WelcomeScreen.vue";
// import Medgate from "../views/Medgate.vue";
// import AnleitungMedgate from "../views/AnleitungMedgate.vue";
// import ContactMedgate from "../views/ContactMedgate.vue";
// import ContactBetterDoc from "../views/ContactBetterDoc.vue";
// import BetterDoc from "../views/BetterDoc.vue";
// import AnleitungBetterDoc from "../views/AnleitungBetterDoc.vue";
// import Coaching from "../views/Coaching.vue";
// import AnleitungCoaching from "../views/AnleitungCoaching.vue";
// import ZTK from "../views/ZTK.vue";
// import ZTKCard from "../views/ZTKCard.vue";
// import AnleitungZTK from "../views/AnleitungZTK.vue";
// import AnleitungZTKNotBot from "../views/AnleitungZTKNotBot.vue";
// import MedicalContact from "../views/MedicalContact.vue";
// import AnleitungMedicalContact from "../views/AnleitungMedicalContact.vue";
// import Arag from "../views/Arag.vue";
// import NachDerGeburt from "../views/NachDerGeburt.vue";
// import NachDerGeburtItem from "../views/NachDerGeburtItem.vue";
// import AragZahn from "../views/AragZahn.vue";
// import AragMental from "../views/AragMental.vue";
// import AnleitungArag from "../views/AnleitungArag.vue";
// import axios from "../plugins/axios";
// import AnleitungAragZahn from "../views/AnleitungAragZahn.vue";
// import Privacy from "../views/Privacy.vue";
// import Profile from "../views/Profile.vue";
// import RoodieChecks from "../views/RoodieChecks.vue";
// import RoodieChecksItem from "../views/RoodieChecksItem.vue";
// import RoodieCheckShare from "../views/RoodieCheckShare.vue";
// import Einstellungen from "../views/Einstellungen.vue";
// import Contact from "../views/Contact.vue";
// import Video from "../views/Video.vue";

// const routes: Array<RouteRecordRaw> = [
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    props: true,
    meta: { gtm: "Home" },
  },
  {
    path: "/welcomescreen",
    name: "welcomescreen",
    component: () => import("../views/WelcomeScreen.vue"),
    props: true,
    meta: { gtm: "WelcomeScreen" },
  },

  {
    path: "/profil",
    name: "profil",
    component: () => import("../views/Profile.vue"),
    meta: { gtm: "Profil" },
  },
  {
    path: "/roodie-safe",
    name: "roodie-safe",
    component: () => import("../views/RoodieSafe.vue"),
    meta: { gtm: "Roodie.Safe" },
  },
  {
    path: "/roodie-checks",
    name: "roodie-checks",
    component: () => import("../views/RoodieChecks.vue"),
    meta: { gtm: "Roodie.Checks" },
  },
  {
    path: "/roodie-checks/:id",
    name: "roodie-checks-item",
    component: () => import("../views/RoodieChecksItem.vue"),
    props: true,
    meta: { gtm: "Roodie.Checks Details" },
  },
  {
    path: "/roodie-check-share",
    name: "roodie-check-share",
    component: () => import("../views/RoodieCheckShare.vue"),
    meta: { gtm: "Roodie.Check Share" },
  },
  {
    path: "/intro",
    name: "intro",
    component: () => import("../views/IntroSlider.vue"),
    meta: { gtm: "Intro" },
  },
  {
    path: "/registrierung",
    name: "registrierung",
    component: () => import("../views/Registrierung.vue"),
    meta: { gtm: "Registrierung" },
  },
  {
    path: "/mtan",
    name: "mtan",
    component: () => import("../views/Mtan.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
    meta: { gtm: "Login" },
  },
  {
    path: "/medgate",
    name: "medgate",
    props: true,
    component: () => import("../views/Medgate.vue"),
    meta: { gtm: "Über Medgate" },
  },
  {
    path: "/medgate/anleitung",
    name: "medgate-anleitung",
    component: () => import("../views/AnleitungMedgate.vue"),
    meta: { gtm: "Medgate Anleitung" },
  },
  {
    path: "/medgate/kontakt",
    name: "medgate-kontakt",
    component: () => import("../views/ContactMedgate.vue"),
    meta: { gtm: "Medgate Kontakt" },
  },
  {
    path: "/betterdoc/kontakt",
    name: "betterdoc-kontakt",
    props: true,
    component: () => import("../views/ContactBetterDoc.vue"),
    meta: { gtm: "BetterDoc Kontakt" },
  },
  {
    path: "/betterdoc",
    name: "betterdoc",
    props: true,
    component: () => import("../views/BetterDoc.vue"),
    meta: { gtm: "Über BetterDoc" },
  },
  {
    path: "/betterdoc/anleitung",
    name: "betterdoc-anleitung",
    props: true,
    component: () => import("../views/AnleitungBetterDoc.vue"),
    meta: { gtm: "BetterDoc Anleitung" },
  },
  {
    path: "/coaching",
    name: "coaching",
    component: () => import("../views/Coaching.vue"),
    meta: { gtm: "Über MedicalContact" },
  },
  {
    path: "/coaching/anleitung",
    name: "coaching-anleitung",
    component: () => import("../views/AnleitungCoaching.vue"),
    meta: { gtm: "MedicalContact Anleitung" },
  },
  {
    path: "/ztk",
    name: "ztk",
    component: () => import("../views/ZTK.vue"),
    props: true,
    meta: { gtm: "ZTK ARAG-Vorteile" },
  },
  {
    path: "/zahnarzt-ztk",
    name: "zahnarzt-ztk",
    component: () => import("../views/ZTKCard.vue"),
    props: true,
    meta: { gtm: "Über ZTK" },
  },
  {
    path: "/qualitysmile",
    name: "qualitysmile",
    component: () => import("../views/QualitySmile.vue"),
    props: true,
    meta: { gtm: "Über Quality Smile" },
  },
  {
    path: "/ztk/anleitung",
    name: "ztk-anleitung",
    component: () => import("../views/AnleitungZTK.vue"),
    meta: { gtm: "ZTK Anleitung" },
  },
  {
    path: "/ztk/anleitung_notbot",
    name: "ztk-anleitung_notbot",
    component: () => import("../views/AnleitungZTKNotBot.vue"),
    meta: { gtm: "ZTK Anleitung Not Bot" },
  },
  {
    path: "/medical-contact",
    name: "medical-contact",
    component: () => import("../views/MedicalContact.vue"),
  },
  {
    path: "/medical-contact/anleitung",
    name: "medical-contact-anleitung",
    component: () => import("../views/AnleitungMedicalContact.vue"),
  },
  {
    path: "/arag",
    name: "arag",
    component: () => import("../views/Arag.vue"),
    meta: { gtm: "Über ARAG CM" },
  },
  {
    path: "/nachdergeburt",
    name: "nachdergeburt",
    component: () => import("../views/NachDerGeburt.vue"),
    meta: { gtm: "Nach der Geburt" },
  },
  {
    path: "/nachdergeburt/:id",
    name: "nachdergeburt-item",
    component: () => import("../views/NachDerGeburtItem.vue"),
    meta: { gtm: "Nach der Geburt Details" },
    props: true,
  },
  {
    path: "/zahn-ratgeber",
    name: "zahn-ratgeber",
    component: () => import("../views/ZahnRatgeber.vue"),
    meta: { gtm: "Ratgeber zur Zahnzusatzversicherung" },
  },
  {
    path: "/arag-mental",
    name: "arag-mental",
    component: () => import("../views/AragMental.vue"),
    meta: { gtm: "Über ARAG CM Mental" },
    props: true,
  },
  {
    path: "/arag-zahn",
    name: "arag-zahn",
    component: () => import("../views/AragZahn.vue"),
    meta: { gtm: "Über ARAG CM Zahn" },
  },
  {
    path: "/arag-koerperlich",
    name: "arag-koerperlich",
    component: () => import("../views/AragKoerperlich.vue"),
    meta: { gtm: "Über ARAG CM Körperlich" },
  },
  {
    path: "/arag/anleitung",
    name: "arag-anleitung",
    component: () => import("../views/AnleitungArag.vue"),
    meta: { gtm: "ARAG CM Anleitung" },
  },
  {
    path: "/arag-zahn/anleitung",
    name: "arag-zahn-anleitung",
    component: () => import("../views/AnleitungAragZahn.vue"),
    meta: { gtm: "ARAG CM Zahn Anleitung" },
  },
  {
    path: "/datenschutz",
    name: "datenschutz",
    component: () => import("../views/Privacy.vue"),
    props: true,
    meta: { gtm: "Datenschutz" },
  },
  {
    path: "/einstellungen",
    name: "einstellungen",
    component: () => import("../views/Einstellungen.vue"),
    props: true,
    meta: { gtm: "Einstellungen" },
  },
  {
    path: "/kontakt",
    name: "kontakt",
    component: () => import("../views/Contact.vue"),
    meta: { gtm: "Kontakt" },
  },
  {
    path: "/video",
    name: "video",
    component: () => import("../views/Video.vue"),
    meta: { gtm: "Video" },
  },
  {
    path: "/information",
    name: "information",
    component: () => import("../views/Information.vue"),
    meta: { gtm: "Information" },
  },
  {
    path: "/termine-aerzte",
    name: "termine-aerzte",
    component: () => import("../views/TermineAerzte.vue"),
    meta: { gtm: "Termine & Ärzte" },
  },
  {
    path: "/nachrichten",
    name: "nachrichten",
    component: () => import("../views/Nachrichten.vue"),
    meta: { gtm: "Nachrichten" },
  },
  {
    path: "/nachrichten/:caseId",
    name: "nachrichten-item",
    component: () => import("../views/NachrichtenItem.vue"),
    meta: { gtm: "Nachrichten Details" },
  },
  {
    path: "/befunde",
    name: "befunde",
    component: () => import("../views/Befunde.vue"),
    meta: { gtm: "Befunde & Co" },
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import("../views/Faq.vue"),
    meta: { gtm: "FAQ" },
  },
  {
    path: "/behandlungsplan-pruefen",
    name: "behandlungsplan-pruefen",
    component: () => import("../views/BehandlungsplanPruefen.vue"),
    meta: { gtm: "Behandlungsplan prüfen" },
  },
  // {
  //   path: "/tabs/",
  //   name: "tabs",
  //   component: () => import("../views/Tabs.vue"),
  //   children: [
  //     {
  //       path: "",
  //       name: "tabs-default",
  //       redirect: "/tabs/tab1",
  //     },
  //     {
  //       path: "tab1",
  //       name: "tabs-tab1",
  //       component: () => import("@/views/Home.vue"),
  //     },
  //     {
  //       path: "tab2",
  //       name: "tabs-tab2",
  //       component: () => import("@/views/Dashboard.vue"),
  //     },
  //     {
  //       path: "tab3",
  //       name: "tabs-tab3",
  //       component: () => import("@/views/Tab3.vue"),
  //     },
  //   ],
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to) => {
  // console.log("router.beforeEach", to);
  if (
    ![
      "/login",
      "/registrierung",
      "/intro",
      "/roodie-check-share",
      "/kontakt",
    ].includes(to.path)
  ) {
    try {
      const isLoggedIn = await apiIsLoggedIn();
      if (!isLoggedIn?.data?.Result) {
        store.commit("setRouteAfterLogin", { path: to.path, query: to.query });
        return "/login";
      }
    } catch (error) {
      console.log(error);
      return "/login";
    }
    // try {
    //   const isLoggedIn = await apiIsLoggedIn();
    //   if (isLoggedIn?.data?.Result) {
    //     next();
    //   } else {
    //     store.commit("setRouteAfterLogin", { path: to.path, query: to.query });
    //     next("/login");
    //   }
    // } catch (error) {
    //   console.log(error);
    //   next("/login");
    // }
  }
  // else if (to.path === "/login") {
  //   const isLoggedIn = await apiIsLoggedIn();
  //   if (isLoggedIn.data.Result) {
  //     next("/home");
  //   } else {
  //     next();
  //   }
  // }
  // else {
  //   next();
  // }
});

// router.afterEach((to, from) => {
//   console.log("router after to", to);
//   console.log("router after from", from);
//   console.log("router after router", router);
//   // if (to.path === from.path) {
//   //   router.replace({ name: to.name });
//   // }
// });

export default router;
